import { notificationService } from './notificationService';

/**
 * Approval Email Service
 * Sends welcome/approval notification emails via Resend when admin approves students or institutes
 */

export const approvalEmailService = {
  /**
   * Send approval email to a student when admin approves their account
   */
  async sendStudentApprovalEmail({ studentName, studentEmail }) {
    const html = `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #f8fafc;">
        <div style="background: white; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 6px rgba(0,0,0,0.07);">
          
          <!-- Header -->
          <div style="background: linear-gradient(135deg, #2563eb 0%, #7c3aed 100%); padding: 32px 40px; text-align: center;">
            <h1 style="color: white; margin: 0; font-size: 28px; font-weight: 700; letter-spacing: -0.5px;">Studyexpo</h1>
            <p style="color: rgba(255,255,255,0.85); margin: 8px 0 0 0; font-size: 14px;">Virtual Education Fair Platform</p>
          </div>

          <!-- Success Banner -->
          <div style="background: #f0fdf4; border-bottom: 3px solid #22c55e; padding: 24px 40px; text-align: center;">
            <div style="display: inline-block; background: #22c55e; border-radius: 50%; width: 56px; height: 56px; line-height: 56px; text-align: center; margin-bottom: 12px;">
              <span style="color: white; font-size: 28px;">✓</span>
            </div>
            <h2 style="color: #15803d; margin: 0; font-size: 22px; font-weight: 700;">Account Approved!</h2>
            <p style="color: #166534; margin: 8px 0 0 0; font-size: 15px;">Your registration has been reviewed and approved</p>
          </div>

          <!-- Body -->
          <div style="padding: 32px 40px;">
            <p style="color: #334155; font-size: 16px; margin: 0 0 16px 0;">Hi <strong>${studentName || 'there'}</strong>,</p>
            <p style="color: #475569; font-size: 15px; line-height: 1.6; margin: 0 0 24px 0;">
              Great news! Your Studyexpo student account has been <strong style="color: #15803d;">approved</strong> by our admin team. 
              You now have full access to the platform and can start exploring educational opportunities.
            </p>

            <!-- Features unlocked -->
            <div style="background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px; padding: 20px; margin-bottom: 24px;">
              <h3 style="color: #1e293b; font-size: 15px; font-weight: 600; margin: 0 0 16px 0;">🎉 What you can do now:</h3>
              <div style="display: flex; flex-direction: column; gap: 10px;">
                <div style="display: flex; align-items: flex-start; gap: 10px;">
                  <span style="color: #2563eb; font-size: 18px; line-height: 1;">💬</span>
                  <div>
                    <strong style="color: #1e293b; font-size: 14px;">Live Chat with Institutes</strong>
                    <p style="color: #64748b; font-size: 13px; margin: 2px 0 0 0;">Chat directly with admission counselors in real-time</p>
                  </div>
                </div>
                <div style="display: flex; align-items: flex-start; gap: 10px;">
                  <span style="color: #7c3aed; font-size: 18px; line-height: 1;">🎥</span>
                  <div>
                    <strong style="color: #1e293b; font-size: 14px;">Video Counseling Sessions</strong>
                    <p style="color: #64748b; font-size: 13px; margin: 2px 0 0 0;">Book one-on-one video sessions with institute representatives</p>
                  </div>
                </div>
                <div style="display: flex; align-items: flex-start; gap: 10px;">
                  <span style="color: #0891b2; font-size: 18px; line-height: 1;">🏛️</span>
                  <div>
                    <strong style="color: #1e293b; font-size: 14px;">Virtual Exhibition Hall</strong>
                    <p style="color: #64748b; font-size: 13px; margin: 2px 0 0 0;">Explore virtual booths from top educational institutions</p>
                  </div>
                </div>
                <div style="display: flex; align-items: flex-start; gap: 10px;">
                  <span style="color: #d97706; font-size: 18px; line-height: 1;">🎓</span>
                  <div>
                    <strong style="color: #1e293b; font-size: 14px;">Webinars & Events</strong>
                    <p style="color: #64748b; font-size: 13px; margin: 2px 0 0 0;">Attend live webinars and educational sessions</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- CTA -->
            <div style="text-align: center; margin-bottom: 24px;">
              <a href="https://edufaircon9190.builtwithrocket.new/institute-login" 
                 style="display: inline-block; background: linear-gradient(135deg, #2563eb 0%, #7c3aed 100%); color: white; text-decoration: none; padding: 14px 36px; border-radius: 8px; font-size: 16px; font-weight: 600; letter-spacing: 0.3px;">
                Login to Your Dashboard →
              </a>
            </div>

            <p style="color: #64748b; font-size: 14px; line-height: 1.6; margin: 0;">
              If you have any questions, feel free to reach out to our support team. We're here to help you find the perfect educational institution!
            </p>
          </div>

          <!-- Footer -->
          <div style="background: #f1f5f9; padding: 20px 40px; text-align: center; border-top: 1px solid #e2e8f0;">
            <p style="color: #94a3b8; font-size: 12px; margin: 0;">© 2026 Studyexpo. All rights reserved.</p>
            <p style="color: #94a3b8; font-size: 12px; margin: 6px 0 0 0;">Virtual Education Fair Platform</p>
          </div>
        </div>
      </div>
    `;

    try {
      await notificationService?.sendEmail({
        to: studentEmail,
        subject: '🎉 Your Studyexpo Account Has Been Approved!',html,type: 'student_approval'
      });
      console.log('✅ [ApprovalEmail] Student approval email sent to:', studentEmail);
      return { success: true };
    } catch (error) {
      console.error('❌ [ApprovalEmail] Failed to send student approval email:', error);
      // Don't throw - email failure shouldn't block approval
      return { success: false, error: error?.message };
    }
  },

  /**
   * Send approval email to an institute when admin approves their account
   * DISABLED: Super admin will personally email institutes from their own email after approval.
   * No automated emails are sent to institutes at any stage.
   */
  async sendInstituteApprovalEmail({ instituteName, instituteEmail, contactPerson }) {
    // Email notifications to institutes are disabled.
    // Super admin contacts institutes personally after approval.
    console.log('[ApprovalEmail] Institute email notifications disabled. Super admin will contact institute manually:', instituteName);
    return { success: true, skipped: true };
  }
};
